import { axiosInstance } from 'boot/axios.js'

export async function measures(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'b2b-on/measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('measures', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function landApplications(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'land-applications',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('landApplications', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function shaftApplications(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'shaft-applications',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('shaftApplications', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}
